export enum AnalyticsSource {
	COMMENTS_PANEL = 'commentsPanel',
	STANDALONE = 'standalone',
	PAGE_FOOTER = 'pageFooter',
}

export enum ActionName {
	REOPEN_COMMENT = 'reopenComment',
}

export enum CommentType {
	INLINE = 'inline',
	GENERAL = 'general',
}
